import { useState } from "react";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";
import { Mail, Check } from "lucide-react";

export default function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/newsletter/subscribe`, { email, name });
      if (r.data.already) toast.info("Sei già iscritto. Ti scriviamo presto.");
      else toast.success("Iscrizione avvenuta. Ti scriveremo solo cose che servono.");
      setDone(true);
      setEmail(""); setName("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 text-sm text-tc-accent" data-testid="newsletter-done">
        <Check className="w-4 h-4" /> Ti scriveremo presto.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={`${compact ? '' : 'bg-tc-surface rounded-3xl p-8 border border-tc/50'}`} data-testid="newsletter-form">
      {!compact && (
        <>
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-tc-secondary mb-3">
            <Mail className="w-3.5 h-3.5" /> Newsletter · in arrivo
          </div>
          <h3 className="font-serif text-2xl md:text-3xl text-tc-primary mb-2">Ricevi notizie e aggiornamenti</h3>
          <p className="text-sm text-tc-muted mb-2">Una mail ogni tanto, mai spam. Eventi, nuove realtà, racconti dalla rete.</p>
          <p className="text-xs text-tc-accent italic mb-5">Stiamo costruendo la prima newsletter: iscriviti ora, non perderai il primo invio.</p>
        </>
      )}
      <div className={`flex ${compact ? 'flex-col sm:flex-row' : 'flex-col md:flex-row'} gap-3`}>
        {!compact && (
          <input type="text" placeholder="Nome (opzionale)" value={name} onChange={e => setName(e.target.value)}
            className="bg-transparent border-b border-tc py-3 outline-none focus:border-tc-primary md:w-1/3" data-testid="newsletter-name" />
        )}
        <input type="email" required placeholder="la-tua-email@esempio.it" value={email} onChange={e => setEmail(e.target.value)}
          className="flex-1 bg-transparent border-b border-tc py-3 outline-none focus:border-tc-primary" data-testid="newsletter-email" />
        <button type="submit" disabled={busy} className="btn-primary !py-3 !px-6 text-sm" data-testid="newsletter-submit">
          {busy ? "…" : "Iscriviti"}
        </button>
      </div>
    </form>
  );
}
